module.exports = __webpack_public_path__ + "img/arturo-de-la-fuente.94b85fc2.jpg";